import { render, staticRenderFns } from "./monthCalendar.vue?vue&type=template&id=ed4b56f4"
import script from "./monthCalendar?vue&type=script&lang=js&external"
export * from "./monthCalendar?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports